import { useState, useRef, useEffect } from "react";
import { Search, ChevronDown, Check } from "lucide-react";
import styles from "./CommonDropDown.module.css";

export const CommonDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // Will store either the selected `id` or string
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Helper function to get the display text (handles both string and object cases)
  const getOptionText = (option) => {
    return typeof option === "string" ? option : option?.name;
  };

  // Helper function to get the selected option's display text
  const getSelectedText = () => {
    if (selectedOption) {
      const foundOption = props?.options?.find((option) =>
        typeof option === "string"
          ? option === selectedOption
          : option.id === selectedOption
      );
      return getOptionText(foundOption);
    }
    return null;
  };
 

  const filteredOptions = Array.isArray(props?.options)
  ? props.options.filter((option) =>
      getOptionText(option).toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];


  useEffect(() => {
    setSelectedOption(props?.value);
  }, [props?.value]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    const value =
      option === "clear"
        ? null
        : typeof option === "string"
        ? option
        : option?.id;
    setSelectedOption(value); // Clear or set selected option
    setIsOpen(false);
    setSearchTerm("");

    // Simulate an event-like object to pass to onChange
    const event = { target: { name: props.name, value } };
    props.onChange(event);
  };

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      <div
        className={`form-control ${styles.dropdownHeader}`}
        onClick={toggleDropdown}
      >
        <span
          className={
            getSelectedText() ? styles.headerText : styles.placeholderTex
          }
        >
          {getSelectedText() || props?.placeholder}
        </span>
        <ChevronDown
          className={`${styles.icon} ${isOpen ? styles.rotated : ""}`}
        />
      </div>
      {isOpen && (
        <div className={styles.dropdownContent}>
          <div className={styles.searchContainer}>
            <Search className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Search options..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>
          <div className={styles.optionsContainer}>
            <ul className={styles.optionsList}>
              {/* Empty option for clearing selection */}
              <li
                onClick={() => handleOptionClick("clear")}
                className={`${styles.option} ${
                  selectedOption === null ? styles.selected : ""
                }`}
              >
                <span>Clear selection</span>
                {selectedOption === null && (
                  <Check className={styles.checkIcon} />
                )}
              </li>

              {/* Render other filtered options */}
              {filteredOptions.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`${styles.option} ${
                    selectedOption ===
                    (typeof option === "string" ? option : option.id)
                      ? styles.selected
                      : ""
                  }`}
                >
                  <span>{getOptionText(option)}</span>
                  {selectedOption ===
                    (typeof option === "string" ? option : option.id) && (
                    <Check className={styles.checkIcon} />
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
